"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const pageLoader_1 = __importDefault(require("../../../../router/loaders/pageLoader"));
const footer_1 = __importDefault(require("../../../organisms/footer"));
const useTeamsState_1 = require("../../../pages/teamSettings/overview/hooks/useTeamsState");
const cardsTable_1 = __importDefault(require("./cardsTable"));
require("./index.less");
const EnrollCardAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../../organisms/createTeamModal/enrollCardAside'))));
const CardDetailsAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./CardDetailsAside'))));
const SelectAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../../organisms/createTeamModal/selectAside'))));
const CompanySettingsCardsTemplate = ({ includeSelectTeams, cardSource = {}, cardOptions = [], toggleCard = () => ({}), onRemoveCard = () => ({}), onSelectTeams = () => ({}), includeRemoveCard = false, saveConfirmAside = () => ({}), submitCardSourceData = () => ({}), toggleCardDetailsAside = () => ({}), toggleAddCardSourceAside = () => ({}), }) => {
    const state = (0, useTeamsState_1.useTeamsState)();
    const [model, setModel] = (0, react_1.useState)({});
    const teamsIdsCardAssigned = state.cardSourceTeams
        ?.filter(card => card.state === appConstants_1.userStatus.ACTIVE)
        .map(card => card.id);
    (0, react_1.useEffect)(() => {
        setModel({ ...model, id: teamsIdsCardAssigned });
    }, [state.cardSourceTeams]);
    (0, react_1.useEffect)(() => {
        state.setFooterButtons([
            {
                id: 'enrollNewCard',
                dataTestId: 'enrollNewCard-btn',
                label: strings_1.companySettingsCardStrings.ENROLL_NEW_CARD,
                color: uiConstants_1.UI_BUTTON_PRIMARY,
                onclick: () => toggleAddCardSourceAside(true),
            },
        ]);
    }, [state.setFooterButtons, toggleAddCardSourceAside]);
    const toggleSelectAside = value => {
        if (!value) {
            setModel({ ...model, id: teamsIdsCardAssigned });
            toggleCardDetailsAside(true);
        }
        state.setIsSelectTeamsOpen({ isOpen: value });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Paper, { "ts-variant": "container", children: (0, jsx_runtime_1.jsx)(cardsTable_1.default, { isTeamCards: false }) }), (0, jsx_runtime_1.jsx)(footer_1.default, {}), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(EnrollCardAside, { submitCardSourceData: submitCardSourceData, asideTitle: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? strings_1.enrollSourceCardStrings.CARD_HEADER_TEXT_HSBC
                        : strings_1.enrollSourceCardStrings.CARD_HEADER_TEXT }) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(CardDetailsAside, { options: cardOptions, cardSource: cardSource, toggleCard: toggleCard, onRemoveCard: onRemoveCard, onSelectTeams: onSelectTeams, saveConfirmAside: saveConfirmAside, includeRemoveCard: includeRemoveCard, includeSelectTeams: includeSelectTeams, onClose: toggleCardDetailsAside, asideTitle: strings_1.cardDetailStrings.CARD_DETAILS_ASIDE_TITLE_TEXT }) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(SelectAside, { model: model, setModel: setModel, emptyMessage: '', options: cardOptions, hasSelectAll: false, isMultiSelect: true, optionProperty: 'name', onSubmit: onSelectTeams, allowEmptySelection: true, isOpen: state.selectTeams.isOpen, title: strings_1.cardDetailStrings.SELECT_TEAMS, onClose: () => toggleSelectAside(false), selectAllLabel: strings_1.cardDetailStrings.ALL_TEAMS_LABEL_TEXT, submitButtonText: strings_1.cardDetailStrings.APPLY_BUTTON_TEXT }) })] }));
};
exports.default = CompanySettingsCardsTemplate;
